// Base URL of your backend
export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const BASE_ROOT = process.env.REACT_APP_BASE_URL_ROOT || process.env.REACT_APP_BASE_URL?.replace(/\/api$/, "");

// Endpoints
export const API_SUBSCRIBE = `${BASE_URL}/subscribe`;
export const API_LOGIN = `${BASE_URL}/login`;
export const API_REGISTER = `${BASE_URL}/register`;
export const API_EMAIL_SUBSCRIBER = `${BASE_URL}/email_subscribe`;